import { useContext } from "react";
import { MatchesContext } from "../context/context";

export const useMatches = () => {
  const context = useContext(MatchesContext);
  return context;
};
